/**
 * eslint-disable @typescript-eslint/no-explicit-any
 *
 * @format
 */

/** @format */

import type { GetStaticPaths, NextPage } from "next";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { getStaticProps } from "../../../methods/i18n";
import Footer from "../../components/Footer";
import Sec1 from "../../components/our-location/sec1";
import Sec2 from "../../components/our-location/sec2";
import Sec4 from "../../components/our-location/sec4";
import SEO from "../../components/seo";
import LocationFormSection from "../../components/our-location/locationFormSection";
import { useTranslation } from "next-i18next";
import { replaceSpacesAndHyphensWithUnderscores } from "../../components/utils";
import { HeadScriptTag } from "../../components/HeadScriptTag";
import axios from "axios";

const Sec3 = dynamic(
  () => import("../../components/our-location/sec3"), // replace '@components/map' with your component's location
  { ssr: false } // This line is important. It's what prevents server-side render
);

export { getStaticProps };

export const getStaticPaths: GetStaticPaths<{
  location: string;
}> = async () => {
  return {
    paths: [],
    fallback: "blocking",
  };
};

const Location: NextPage = () => {
  const router = useRouter();
  const { location } = router.query;

  const [locationtypeData, setLocationTypeData] = useState<any>();
  const [locationData, setLocationData] = useState<any>();
  const [isMapMounted, setIsMapMounted] = useState<any>(true);

  const fetchData = async () => {
    try {
      const r = await axios({
        url: `https://wp.taxworkoutgroup.com/wp-json/wp/v2/location/?_embed=&per_page=100`,
        method: "get",
      });
      setLocationData(r?.data);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {

    // if(location == 'undefined'){
    //   window.location.href = "/"
    // }

    fetchData();
  }, [location]);

  useEffect(() => {
    if (locationData?.length > 0) {
      const filteredLocationsData = locationData?.find(
        (locationValue: any) => locationValue?.slug === location
      );

      if(!filteredLocationsData){
        router.push('/')
      }
      
      setLocationTypeData(filteredLocationsData);
      setIsMapMounted(false);
    }
  }, [location, locationData]);

  useEffect(() => {
    let timer: any;
    if (!isMapMounted) {
      timer = setTimeout(() => setIsMapMounted(true), 500);
    }
    return () => clearTimeout(timer);
  }, [isMapMounted]);

  const { t } = useTranslation("meta_tags");

  // Modify location name if hyphen or space is there and add underscore if it exists
  const modifiedLocation: string = replaceSpacesAndHyphensWithUnderscores(
    location as string
  );

  const title = location ? t(`${modifiedLocation}`) : t("home");
  const description = location ? t(`${modifiedLocation}_desc`) : t("home_desc");
  const keywords = "Tax,Tax Bankruptcy ,Tax Controversy, Blog";
  // const ogImage = "https://www.example.com/static/images/og-image.jpg";
  const ogType = "article";
  const canonicalURL = location
    ? `https://taxworkoutgroup.com/location/${locationtypeData?.slug}`
    : "https://www.taxworkoutgroup.net";

    console.log(location,"location")

  return (
    <>
      <SEO
        title={title}
        description={description}
        keywords={keywords}
        // ogImage={ogImage}
        ogType={ogType}
        canonicalURL={canonicalURL}
      />
      <HeadScriptTag />
      <Sec1 locationtypeData={locationtypeData} />
      {locationtypeData && (
        <LocationFormSection
          locationtypeData={locationtypeData}
          location={location as string}
        />
      )}
      <Sec2 locationtypeData={locationtypeData} />
      {locationtypeData && isMapMounted ? (
        <Sec3 key={locationtypeData} locationtypeData={locationtypeData} />
      ) : null}
      <Sec4 locationtypeData={locationtypeData} />
      {/* <Sec5 /> */}
      <Footer />
    </>
  );
};

export default Location;
